<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { ref } from "vue";
import VideoIcon from "@/components/icons/VideoIcon.vue";
import ModalComponent from "@/components/ModalComponent.vue";

const { t } = useI18n();
const showInstructionModal = ref(false);
const videoUrl =
  process.env.VUE_APP_URL + "/storage/instruction/planning-instruction.mp4";
</script>

<template>
  <button
    class="shrink-0 h-9 w-full rounded-[100px] border border-brown text-sm text-brown"
    @click="showInstructionModal = true"
  >
    <span class="flex items-center justify-center gap-2">
      <span>
        {{ t("calculators.apartment-plan.actions.video-instruction") }}
      </span>
      <VideoIcon class="size-5" />
    </span>
  </button>
  <ModalComponent
    maxModalSizeClass="max-w-5xl"
    :show="showInstructionModal"
    @close="showInstructionModal = false"
  >
    <template #content>
      <div class="w-full">
        <video controls playsinline preload="metadata" width="100%">
          <source :src="videoUrl" type="video/mp4" />
        </video>
      </div>
    </template>
  </ModalComponent>
</template>

<style scoped></style>
